import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Reveal } from './Reveal';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-139" data-mp="1n00ra3zw93vo">
      <Reveal className="mx-auto max-w-6xl" data-id="element-140" data-mp="1mzisp0predkl">
        <div className="mb-12 text-center" data-id="element-141" data-mp="1r1dvyar93110">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-coral" data-id="element-142" data-mp="1r02r07m2jn8b">ZAUFANIE TRENERÓW</p>
          <h2 className="text-3xl font-black uppercase tracking-tight text-brand-navy md:text-4xl" data-id="element-143" data-mp="1d0jj9fx66dwj">
            Co mówią trenerzy.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-144" data-mp="141g2wjpe0clq">
            ⭐⭐⭐⭐⭐ Stworzone dla pewnych siebie treningów siatkówki
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-145" data-mp="1831jog51lb17">
          {testimonials.map(({
          quote,
          name,
          role
        }) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-146" data-mp="32gspt5o5xcrw">
              <div className="flex gap-1" data-id="element-147" data-mp="2uzrkr7su7nn8">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-coral text-brand-coral" aria-hidden="true" data-id="element-148" data-mp="2q27tn7b1jgdv" />)}
              </div>
              <p className="mt-5 flex-1 font-display text-lg font-semibold italic leading-relaxed" data-id="element-149" data-mp="2zrre2heejiau">{quote}</p>
              <div className="mt-6" data-id="element-150" data-mp="2c1x2s49qe1sp">
                <p className="text-sm font-bold text-brand-navy" data-id="element-151" data-mp="2c2yqp9buiiru">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-152" data-mp="274oqulf6etzw">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}